<template>
  <!--
      	作者：kmdshop
      	时间：2020-06-25
      	描述：插件中心-限时拼团-活动列表-编辑活动-其它
      -->

  <div>
    <div class="common-form">规则设置</div>
    <!-- <el-form-item label="参与营员最大人数">
      <el-input v-model="form.setting.iden_num" style="width: 200px;"></el-input>
    </el-form-item> -->

    <el-form-item label="开团前需要拼团">
      <el-radio-group v-model="form.setting.creator_auth">
        <el-radio label="0">关闭</el-radio>
        <el-radio label="1">开启</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="form.setting.creator_auth == 1" label="开团白名单（用户ID）">
      <el-input v-model="form.setting.whitelist" style="width: 200px;"></el-input>
      <div>说明：设置后，无需拼团也可发起拼团，可多个，逗号隔开</div>
    </el-form-item>
    <el-form-item label="是否免费开团">
      <el-radio-group v-model="form.setting.creator_free">
        <el-radio label="0">关闭</el-radio>
        <el-radio label="1">开启</el-radio>
      </el-radio-group>
    </el-form-item>
    <!-- <el-form-item label="累计参与拼团次数" v-if="form.setting.creator_free == 1">
      <el-radio-group v-model="form.setting.creator_num">
        <el-radio label="0">关闭</el-radio>
        <el-radio label="1">开启</el-radio>
      </el-radio-group>
      <div>说明：开启免费拼团后，则会累计参与拼团次数，一次拼团代表一次开团</div>
    </el-form-item> -->
    <el-form-item label="拼团未满不解散拼团">
      <el-radio-group v-model="form.setting.creator_end">
        <el-radio label="0">关闭</el-radio>
        <el-radio label="1">开启</el-radio>
      </el-radio-group>
      <div>说明：到时间后拼团结束,并且不会退款，订单直接已完成</div>
    </el-form-item>



    <!-- <el-form-item label="拼团收益">
      <el-radio-group v-model="form.setting.profits_open">
        <el-radio label="0">关闭</el-radio>
        <el-radio label="1">开启</el-radio>
      </el-radio-group>
    </el-form-item> -->
    <div v-if="form.setting.profits_open==1">
      <el-form-item label="奖励类型" >
        <el-radio-group v-model="form.setting.profits_type">
          <el-radio label="0">返利</el-radio>
          <el-radio label="1">优惠券</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="返利金额" v-if="form.setting.profits_type==0">
        <div class="max-w460">
          <el-input v-model="form.setting.money" type="number">
            <template slot="append">
                        元
            </template>
          </el-input>
        </div>
      </el-form-item>
      <el-form-item label="奖励优惠券" v-if="form.setting.profits_type==1">
          <el-input class="max-w460" placeholder="点击选择奖励优惠券" v-model="form.setting.coupon_name" :disabled="true"></el-input>
          <el-button icon="el-icon-link" @click="addCoupon()">选择优惠券</el-button>
        </el-form-item>
      <el-form-item label="人数" >
        <div class="max-w460">
          <el-input v-model="form.setting.per_join_num" type="number">
            <template slot="append">
                人
            </template>
          </el-input>
          <div class="tips">每满XX人可以获得一份奖励</div>
        </div>
      </el-form-item>
      <el-form-item label="最多奖励数量" >
        <div class="max-w460">
          <el-input v-model="form.setting.profits_limit" type="number">
            <template slot="append">
                        份
            </template>
          </el-input>
        </div>
      </el-form-item>
    </div>

    <el-form-item label="发放时间" v-if="form.setting.creator_end == 1 && form.setting.profits_open ==1">
      <el-radio-group v-model="form.setting.send_time">
        <el-radio label="0">拼团结束发放</el-radio>
        <el-radio label="1">马上发放</el-radio>
      </el-radio-group>
    </el-form-item>

    <div class="common-form">其它</div>

    <el-form-item label="活动排序" :rules="[{ required: true, message: '请输入活动排序' }]" prop="sort">
      <div class="max-w460">
        <el-input v-model="form.sort" type="number"></el-input>
      </div>
    </el-form-item>
    <el-form-item label="是否生效">
      <el-radio-group v-model="form.status">
        <el-radio :label="0">未生效</el-radio>
        <el-radio :label="1">生效</el-radio>
      </el-radio-group>
    </el-form-item>
    <!--选择优惠券-->
    <GetCoupon v-if="open_add" :open_add="open_add" @closeDialog="closeProductDialogFunc($event)">选择优惠券弹出层</GetCoupon>
  </div>
</template>

<script>
import GetCoupon from '@/components/coupon/GetCoupon';
export default {
  components: {
    GetCoupon
  },
  data(){
    return {
      open_add:false,
    }
  },
  props: ['form'],
  methods:{
    /*添加优惠券*/
    addCoupon() {
      this.open_add = true;
    },
    /*关闭弹窗*/
    closeProductDialogFunc(e) {
      this.open_add = e.openDialog;

      if (e.type == 'success') {
         this.form.setting.coupon_id = e.params.coupon_id;
        this.form.setting.coupon_name = e.params.name;
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/assemble/active/part/Other.vue